import { AxiosRequestConfig } from 'axios'
import { NotaFiscalServiceAdapter, ParamsFindNotaFiscal } from '@/usecases'
import {
	find,
	findReferenciaDaEntrada,
	findNotaDeMesmoValor,
	findInfoNotaComplementarByVendaId,
	findEmitenteDaNota,
	findNotaByChNFe,
} from '@/api/notasFiscais'
import { findRegraPorEstadoBase } from '@/api/impostos'
import { TipoDeClienteRegra, TipoDeTransacaoDeRegraFiscal, TipoEntradaSaidaRegraFiscal } from '@/models';
export class NotaFiscalService implements NotaFiscalServiceAdapter {
	find = async (params?: ParamsFindNotaFiscal) => await find(params);
	findReferenciaDaEntrada = async (sku: string, lojaId: string, cnpjEmitente: string, quantidadeLidaDoProduto: number) => await findReferenciaDaEntrada(sku, lojaId, cnpjEmitente, quantidadeLidaDoProduto)
	findNotaDeMesmoValor = async (destinatario: string, valor: string, params: any) => await findNotaDeMesmoValor(valor, destinatario, params)
	findInfoNotaComplementarByVendaId = async (vendaId: string) => await findInfoNotaComplementarByVendaId(vendaId)
	findEmitenteDaNota = async (chaveNf: string) => await findEmitenteDaNota(chaveNf)
	findNotaByChNFe = async (chaveNf: string) => await findNotaByChNFe(chaveNf)

	findRegraPorEstadoBase = async (
		produtoId: string,
		lojaId: string,
		tipoDeCliente: TipoDeClienteRegra,
		ufDestino: string,
		tipoDeTransacaoRegraFiscal: TipoDeTransacaoDeRegraFiscal,
		tipoEntradaSaidaRegraFiscal: TipoEntradaSaidaRegraFiscal,
		config?: AxiosRequestConfig,
	) => await findRegraPorEstadoBase(produtoId, lojaId, tipoDeCliente, ufDestino, tipoDeTransacaoRegraFiscal, tipoEntradaSaidaRegraFiscal, config)
}